import { graphql } from "gatsby";
import React from "react";
import  Hero  from "../components/Hero/Hero";
import { ContactForm } from "../components/ContactForm/ContactForm";
import ContactSocials from "../components/ContactSocials/ContactSocial";
import Seo from "../components/seo";
import {useUrl} from '../hooks/layout/useUrl'
const PageContactUs = ({
    location,
    pageContext,
    data : {
        contentfulPageCustom
    }
})=>{
    const lang = useUrl()
    
    const {seoTitle, seoDescription, node_locale, carelineScript, subHeading} = contentfulPageCustom
    return(
        <>
             <Seo
                title={seoTitle}
                description={seoDescription && seoDescription.seoDescription}
                node_locale={node_locale}
                lang = {lang}
            />
            <div className="text-center">
                <Hero data = {contentfulPageCustom}/>
            </div>
            <ContactForm carelineScript = {carelineScript} subHeading ={subHeading}/>
            <ContactSocials />
        </>
    )
}

export const PageContactUsQuery = graphql`
    query pageContactUs($id:String!){
        contentfulPageCustom(id:{eq:$id}){
            title
            seoTitle
            seoDescription{
                seoDescription
            }
            node_locale
            slug
            description {
                raw
              }
            carelineScript
            subHeading
        }
    }
`

export default PageContactUs;